import orderConverter from '../../util/order_converter.js';
import {
  newDefaultAsapSelfDeliveryOrder,
  defaultAsapSelfDeliveryOrder,
  anticipatedFuturePickupOrder,
  cancelledAsapSelfDeliveryOrder,
  cashAsapSelfDeliveryOrder,
  cashAsapPickupOrder,
  merchantPhoneNumber,
  confirmedFutureMockOrder,
  unconfirmedFuturePickupOrder,
  adjustedAsapGHDOrder,
  adjustedAsapSelfDeliveryOrder,
  redactedAsapSelfDeliveryOrder,
  redactedAsapGHDOrder,
  cateringAsapGHDOrder,
  cateringFutureGHDOrder,
  cateringFutureGHDNoLineInfoOrder,
  groupOrder,
  groupOrderGhd,
  groupAllActiveOrder,
  groupAdjustedOrder,
  groupCancelledSomeDiners,
  groupCancelledOrder,
  oneItemAsapSelfDeliveryOrder,
  vanillaAsapPickupOrder,
  vanillaAsapGhDirectPickupOrder,
  vanillaAsapSelfDeliveryOrder,
  ghdAsPickup,
  newDefaultAsapGHDeliveryOrder,
  singleCartTaxExemptedOrderCorpLoc,
  multiCartTaxExemptedOrderCorpLoc,
  seamlessDefaultASAPDeliveryOrder,
  eat24DefaultASAPDeliveryOrder,
  useDmpFields,
  wonderDefaultASAPDeliveryOrder
} from '../../util/mock_orders.js';
import {
  defaultView, oneItemView, newDefaultOrderView, cateringOrderView, sgoGhdOrderView
} from '../../util/mock_views.js';
import {
  defaultMerchant
} from '../../util/mock_merchants'
import CodedError, {ERROR_CODE} from '../../util/CodedError';
import moment from 'moment';

class HomeService {
  constructor($http, $q, $location, errorService, foodPrepTimeService) {
    this.$http = $http;
    this.$q = $q;
    this.$location = $location;
    this.errorService = errorService;
    this.foodPrepTimeService = foodPrepTimeService
  }

  getHost() {
    const host = this.$location.host();
    if (host.includes("grubhub.com")) {
      return "https://api-order-processing-gtm.grubhub.com";
    } else {
      return "https://api-order-processing-gtm-pp.grubhub.com";
    }
  }

  /**
   * Grabs the order model from the confirmation email services:
   * @param {String} authToken
   * @param {String} supervisorToken
   * @param {String} foodPrepDuration
   * @returns {ConvertedModel|{}}
   * @public
   */
  getModel(authToken, supervisorToken, foodPrepDuration) {
    const host = this.getHost();
    let url = `${host}/order/email/confirm/${authToken}/${supervisorToken}`;
    if (Number.isInteger(+foodPrepDuration)) url += `?foodPrepDuration=${foodPrepDuration}`;
    return this.postConfirmOrder(url, authToken, supervisorToken);
  }

  getFoodPrepTimeConfirmedOrder() {
    return this.foodPrepTimeService.getConfirmedOrder();
  }

  getModelWithId(custId, authToken, supervisorToken, foodPrepDuration) {
    const host = this.getHost();
    let url = `${host}/order/email/confirm/${custId}/${authToken}/${supervisorToken}`;
    if (Number.isInteger(+foodPrepDuration)) url += `?foodPrepDuration=${foodPrepDuration}`;
    return this.postConfirmOrder(url, authToken, supervisorToken, custId);
  }

  postConfirmOrder(url, authToken, supervisorToken, custId) {
    return this.$http.post(url, {})
      .then(
        (response) => {
          return orderConverter.convert(response.data);
        },
        (responseError) => {
          switch (responseError.status) {
            case 410: return this.$q.reject(new CodedError(responseError, ERROR_CODE.TOKENS_EXPIRED));
            default: return this.$q.reject(new CodedError(responseError, ERROR_CODE.CONFIRMATION_FAILURE, {authToken, supervisorToken, custId}));
          }
        }
      );
  }

  testGHDeliveryOrder() {
      const order = newDefaultAsapGHDeliveryOrder;
      const view = newDefaultOrderView;
      const merchant = defaultMerchant;
      order.merchantFulfillmentTime = moment.utc().format();
      order.requestedFulfillmentAt = moment.utc().format();
      return this.$q.when(orderConverter.convert({ order, merchantPhoneNumber, view, merchant }));
  }

  testPickupOrder() {
      var order = vanillaAsapPickupOrder;
      order.merchantFulfillmentTime = moment.utc().format();
      order.requestedFulfillmentAt = moment.utc().format();
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

    testGhDirectPickupOrder() {
        var order = vanillaAsapGhDirectPickupOrder;
        order.merchantFulfillmentTime = moment.utc().format();
        order.requestedFulfillmentAt = moment.utc().format();
        return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
    }

  testSelfDeliveryOrder() {
    const order = vanillaAsapSelfDeliveryOrder;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(
      orderConverter.convert({
        order,
        merchantPhoneNumber,
        view: defaultView
      })
    );
  }

   testCashOrder() {
    const order = cashAsapSelfDeliveryOrder;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(
      orderConverter.convert({
        order,
        merchantPhoneNumber,
        view: defaultView
      })
    );
  }

  testCashPickupOrder() {
    const order = cashAsapPickupOrder;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(
      orderConverter.convert({
        order,
        merchantPhoneNumber,
        view: defaultView
      })
    );
  }

  testGHDeliveryOrderWithOneItem() {
    var order = oneItemAsapSelfDeliveryOrder;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: oneItemView}));
  }

  testGHDasPickup() {
    var order = ghdAsPickup;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: oneItemView}));
  }

  testAdjustedPickupOrder() {
      var order = defaultAsapSelfDeliveryOrder;
      order.merchantFulfillmentTime = moment.utc().format();
      order.requestedFulfillmentAt = moment.utc().format();
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testAdjustedOrderWithRestaurantTotals() {
      var order = adjustedAsapGHDOrder;
      order.merchantFulfillmentTime = moment.utc().format();
      order.requestedFulfillmentAt = moment.utc().format();
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testAdjustedOrderServiceFee() {
      return this.$q.when(orderConverter.convert({ order: adjustedAsapSelfDeliveryOrder, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testNonConfirmedOrder() {
      return this.$q.when(orderConverter.convert({ order: anticipatedFuturePickupOrder, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testUnconfirmedFutureOrder() {
      var order = unconfirmedFuturePickupOrder;
      order.merchantFulfillmentTime = moment.utc().add(1, 'months').format();
      order.requestedFulfillmentAt = moment.utc().add(1, 'months').format();
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testConfirmedFutureOrder() {
      var order = confirmedFutureMockOrder;
      order.merchantFulfillmentTime = moment.utc().add(1, 'months').format();
      order.requestedFulfillmentAt = moment.utc().add(1, 'months').format();
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testCancelledOrder() {
      return this.$q.when(orderConverter.convert({ order: cancelledAsapSelfDeliveryOrder, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testRedactedOrderNonGHD() {
      return this.$q.when(orderConverter.convert({ order: redactedAsapSelfDeliveryOrder, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testRedactedOrderGHD() {
      return this.$q.when(orderConverter.convert({ order: redactedAsapGHDOrder, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testCateringAsapGHD() {
      const order = cateringAsapGHDOrder;
      const view = cateringOrderView;
      const merchant = defaultMerchant;
      order.merchantFulfillmentTime = moment.utc().format();
      order.requestedFulfillmentAt = moment.utc().format();
      return this.$q.when(orderConverter.convert({ order, merchantPhoneNumber, view, merchant }));
  }

  testCateringFutureGHD() {
      const order = cateringFutureGHDOrder;
      const view = cateringOrderView;
      const merchant = defaultMerchant;
      order.merchantFulfillmentTime = moment.utc().add(1, 'months').format();
      order.requestedFulfillmentAt = moment.utc().add(1, 'months').format();
      return this.$q.when(orderConverter.convert({ order, merchantPhoneNumber, view, merchant }));
  }

  testCateringSelfDelivery() {
    const order = cateringAsapGHDOrder;
    const view = cateringOrderView;
    const merchant = defaultMerchant;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    order.delivery.grubhubDelivery = false;
    return this.$q.when(orderConverter.convert({ order, merchantPhoneNumber, view, merchant }));
  }

  testCateringOrderNoLineInfo() {
      const order = cateringFutureGHDNoLineInfoOrder;
      const view = cateringOrderView;
      const merchant = defaultMerchant;
      order.merchantFulfillmentTime = moment.utc().add(1, 'months').format();
      order.requestedFulfillmentAt = moment.utc().add(1, 'months').format();
      return this.$q.when(orderConverter.convert({ order, merchantPhoneNumber, view, merchant }));
  }

  testSgoOrder() {
      var order = groupOrder;
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testSgoGhdOrder() {
      var order = groupOrderGhd;
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: sgoGhdOrderView }));
  }

  testSgoOrderAllActive() {
      var order = groupAllActiveOrder;
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testSgoOrderAdjusted() {
      var order = groupAdjustedOrder;
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testSgoOrderCancelledDiners() {
      var order = groupCancelledSomeDiners;
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testSgoOrderCancelledOrder() {
      var order = groupCancelledOrder;
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, view: defaultView }));
  }

  testDmpOrderSummary() {
      var order = confirmedFutureMockOrder;
      return this.$q.when(orderConverter.convert({ order: order, merchantPhoneNumber: merchantPhoneNumber, useDmpFields: useDmpFields, view: defaultView }));
  }

  testContactFreeDelivery() {
      const order = newDefaultAsapSelfDeliveryOrder;
      const view = newDefaultOrderView;
      const merchant = defaultMerchant;
      order.merchantFulfillmentTime = moment.utc().format();
      order.requestedFulfillmentAt = moment.utc().format();
      return this.$q.when(orderConverter.convert({
          order,
          merchantPhoneNumber,
          view,
          merchant,
          useContactlessField: true,
          isContactless: true,
          contactlessHandoffLocation: "Leave order at front door of house/apartment unit",
          contactlessContactMethod: "Text customer"
      }));
  }

  testCurbsidePickupNonGHD() {
    const order = newDefaultAsapSelfDeliveryOrder;
    const view = newDefaultOrderView;
    const merchant = defaultMerchant;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({
      order: {...order, delivery: null, handoffOptions: ['CURBSIDE_PICKUP'], merchantPickupContactPhone: '123-456-7890'},
      merchantPhoneNumber,
      view,
      merchant,
      merchantPickupContactPhone: '123-456-7890'
    }));
  }

  testCurbsidePickupGHD() {
    const order = newDefaultAsapSelfDeliveryOrder;
    const view = newDefaultOrderView;
    const merchant = defaultMerchant;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({
      order: {
        ...order,
        delivery: null,
        driverHandoffOptions: {contactPhone: '123-456-9999'}
      },
      view,
      merchant,
      merchantPickupContactPhone: '123-456-7890'
    }));
  }

  testCurbsideAndContactlessDelivery() {
    const order = newDefaultAsapSelfDeliveryOrder;
    const view = newDefaultOrderView;
    const merchant = defaultMerchant;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({
      order: {...order, handoffOptions: ['CURBSIDE_PICKUP'], merchantPickupContactPhone: '123-456-7890'},
      merchantPhoneNumber,
      view,
      merchant,
      useContactlessField: true,
      isContactless: true,
      contactlessHandoffLocation: "Leave order at front door of house/apartment unit",
      contactlessContactMethod: "Text customer"
    }));
  }

  testCurbsideAndContactlessDeliveryGHD() {
    const order = newDefaultAsapGHDeliveryOrder;
    const view = newDefaultOrderView;
    const merchant = defaultMerchant;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({
      order: {
        ...order,
        driverHandoffOptions: {contactPhone: '123-456-9999'}
      },
      merchantPhoneNumber,
      view,
      merchant,
      useContactlessField: true,
      isContactless: true,
      contactlessHandoffLocation: "Leave order at front door of house/apartment unit",
      contactlessContactMethod: "Text customer"
    }));
  }

  testContactlessNoInstructions() {
    const order = newDefaultAsapSelfDeliveryOrder;
    const view = newDefaultOrderView;
    const merchant = defaultMerchant;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({
      order: {...order, specialInstructions: null},
      merchantPhoneNumber,
      view,
      merchant,
      useContactlessField: true,
      isContactless: true,
      contactlessHandoffLocation: "Leave order at front door of house/apartment unit",
      contactlessContactMethod: "Text customer"
    }));
  }

  testOnlyInstructions() {
    const order = newDefaultAsapSelfDeliveryOrder;
    const view = newDefaultOrderView;
    const merchant = defaultMerchant;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({
      order,
      merchantPhoneNumber,
      view,
      merchant
    }));
  }

  testEstimatedFulfillmentAtPickupOrder() {
    let order = vanillaAsapPickupOrder;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({
      order: order,
      merchantPhoneNumber: merchantPhoneNumber,
      view: defaultView,
      estimatedFulfillmentAt: moment.utc().add(30, "minutes").format()
    }));
  }

  testSingleCartTaxExemptedOrder() {
      const order = singleCartTaxExemptedOrderCorpLoc;
      const view = newDefaultOrderView;
      const merchant = defaultMerchant;
      order.merchantFulfillmentTime = moment.utc().format();
      order.requestedFulfillmentAt = moment.utc().format();
      return this.$q.when(orderConverter.convert({ order, merchantPhoneNumber, view, merchant }));
  }

  testMultiCartTaxExemptedOrder() {
      const order = multiCartTaxExemptedOrderCorpLoc;
      const view = sgoGhdOrderView;
      const merchant = defaultMerchant;
      order.merchantFulfillmentTime = moment.utc().format();
      order.requestedFulfillmentAt = moment.utc().format();
      return this.$q.when(orderConverter.convert({ order, merchantPhoneNumber, view, merchant }));
  }

  testSeamlessOrder() {
    const order = seamlessDefaultASAPDeliveryOrder;
    const view = newDefaultOrderView;
    const merchant = defaultMerchant;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({ order, merchantPhoneNumber, view, merchant }));
  }

  testEat24Order() {
    const order = eat24DefaultASAPDeliveryOrder;
    const view = newDefaultOrderView;
    const merchant = defaultMerchant;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({ order, merchantPhoneNumber, view, merchant }));
  }

  testWonderOrder() {
    const order = wonderDefaultASAPDeliveryOrder;
    const view = newDefaultOrderView;
    const merchant = defaultMerchant;
    order.merchantFulfillmentTime = moment.utc().format();
    order.requestedFulfillmentAt = moment.utc().format();
    return this.$q.when(orderConverter.convert({ order, merchantPhoneNumber, view, merchant }));
  }
};

HomeService.$inject = ['$http', '$q', '$location', 'errorService', 'foodPrepTimeService'];

export default HomeService;



// WEBPACK FOOTER //
// ./client/app/components/home/home.service.js